export const MODULE_NAME = 'features'; //BaseApi
export const BETA_FEATURE = 'betafeature';
export const BETA_FEATURES = 'betafeatures';
export const BETA_FEATURES_ALL = 'betafeatures';
export const RELOAD_BETA_FEATURES = 'reloadBetaFeatures';
export const SAVE_BETA_FEATURE = 'saveBetaFeature';
export const GO_LIVE_BETA_FEATURE = 'goLiveBetaFeature';
export const SET_BETA_FEATURE = 'setBetaFeature'; 
export const SET_BETA_FEATURES = 'setBetaFeatures';
export const SET_BETA_FEATURES_ALL = 'setBetaFeaturesAll';
export const SHOW_BETA_FEATURE_MODAL = 'showBetaFeatureModal';
export const SHOW_CUSTOMERS_MODAL = 'showCustomersModal';
export const TOAST_MESSAGES_PUSH = 'toastMessages/push';
export const HISTORY_LOGS = 'historyLogs';
export const SET_HISTORY_LOGS = 'setHistoryLogs';
